export const gaEvents = {
  DISMISS: {
    EVENT_ACTION: 'Dismiss',
    EVENT_LABEL: 'LoginNudge',
  },
  SCROLL_IGNORE: {
    EVENT_ACTION: 'ScrollIgnore',
    EVENT_LABEL: 'LoginNudge',
  },
  FOCUS_IGNORE: {
    EVENT_ACTION: 'FocusIgnore',
    EVENT_LABEL: 'LoginNudge',
  },
  CTA: {
    EVENT_ACTION: 'LoginAction',
    EVENT_LABEL: 'LoginNudge',
  },
};

export const domSelectors = {
  LOGIN_BUTTON: '[data-role="mymp-login"]',
  SEARCH_INPUT: '.mp-Header input[name="query"]',
};

export const rules = {
  PAGE_VIEW_LIMIT: 5,
  REMOVAL_DEBOUNCE_THRESHOLD: 333,
};

export const storageKeys = {
  LAST_DISMISSED: 'MpLoginNudgeDismissDate',
};
